import { ref as s, readonly as n } from "vue";
/**
 * @copyright Copyright (c) 2023 Grigorii K. Shartsev <me@shgk.me>
 *
 * @author Grigorii K. Shartsev <me@shgk.me>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
const r = () => window.outerHeight === screen.height, e = s(r());
window.addEventListener("resize", () => {
  e.value = r();
});
function c() {
  return n(e);
}
const o = n(e);
export {
  o as isFullscreenState,
  c as useIsFullscreen
};
